// extracted by mini-css-extract-plugin
export default {"wrapper":"RD-z","fullName":"SD-z"};